import './favorites-dialog-sk';
